import { render } from "./recordEntry.vue?vue&type=template&id=6e953c74&scoped=true"
import script from "./recordEntry.vue?vue&type=script&lang=js"
export * from "./recordEntry.vue?vue&type=script&lang=js"

import "./recordEntry.vue?vue&type=style&index=0&id=6e953c74&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e953c74"]])

export default __exports__